module.exports = __webpack_public_path__ + "static/media/market-rate-housing-landing.72ee5edb.jpeg";